import { useState } from "react";
import { VStack, Text, Button } from "@chakra-ui/react";
import Link from "next/link";
import { Info } from "lucide-react";
import { CustomDialog } from "components/ui/dialog";

export default function MustUpdateData() {
  const [showCustomDialog, setShowCustomDialog] = useState(true);

  return (
    <CustomDialog
      open={showCustomDialog}
      titleBg="orange.500"
      onClose={() => setShowCustomDialog(false)}
      title="Atualização de Dados"
      showConfirmButton={false}
      icon={<Info size={24} />}
      body={
        <VStack align="center">
          <Text textAlign="start" color="gray.600">
            Em função das atualizações realizadas no site, 
            pedimos que você atualize seus dados cadastrais para garantir o acesso 
            completo a todos os recursos da plataforma.
          </Text>
        </VStack>
      }
      body2={
        <VStack align="center" boxShadow="sm" p="4" borderRadius="lg" bg="gray.100">
            <Text textAlign="start" color="gray.900" mb="2">
                Para atualizar seus dados, clique no botão abaixo e vá até a aba <strong>"Detalhes"</strong> na sua conta.
            </Text>
            <Link href="/conta/menu/minha-conta" passHref>
                <Button as="a" bg="red-wine" color="white" boxShadow="sm" fontWeight="bold" transition="all 0.2s ease" _hover={{transform:"scale(1.1)",bg:"red.600"}}>
                Atualizar Dados
                </Button>
            </Link>
        </VStack>
      }
      cancelText="Fechar"
      onCancel={() => setShowCustomDialog(false)}
      onConfirm={() => {}}
    />
  );
}
